'use client'

export default function Layouts({ children }) {
  return <>{children}</>
}
